import Rupee from '@instamojo/rupee';

export default Rupee;
